<template>
    <div class="error" v-if="errors">
        <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
    </div>
</template>

<script>
export default {
    props: ["errors"]
};
</script>

<style lang="scss" scoped>
.error {
    color: $primary;
    font-size: $text-sm;
}
</style>

